export default "__VITE_ASSET__Dtiswnqn__"